module.exports = __webpack_public_path__ + "img/greening_e.2cc7a70b.gif";